import { routeActions } from 'redux-simple-router';
import { httpGet, httpPost, httpPut } from '../../Util/http';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import { attemptGetActivities } from '../ActivityOverview/actions';

export const GET_ACTIVITY_REQUEST = 'GET_ACTIVITY_REQUEST';
export const getActivitiesRequest = () => {
    return {
        type: GET_ACTIVITY_REQUEST
    }
}

export const GET_ACTIVITY_SUCCESS = 'GET_ACTIVITY_SUCCESS'
export const getActivitySuccess = json => {
    return {
        type: GET_ACTIVITY_SUCCESS,
        rootActivity: json.rootActivity,
        subActivities: json.subActivities,
        activities: json.activities,
        employees: json.employees,
        employees2: json.employees2,
    };
}

export const UPDATE_POOL_REQUEST = 'UPDATE_POOL_REQUEST'
export const updatePoolRequest = val => {
    return {
        type: UPDATE_POOL_REQUEST,
        val: val
    };
}

export const UPDATE_POOL_SUCCCESS = 'UPDATE_POOL_SUCCCESS'
export const updatePoolSuccess = () => {
    return {
        type: UPDATE_POOL_SUCCCESS
    };
}

export const UPDATE_POOL_FAILURE = 'UPDATE_POOL_FAILURE'
export const updatePoolFailure = val => {
    return {
        type: UPDATE_POOL_FAILURE,
        val: val
    };
}


export const updateRootPool = (activityId, date, val) => {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/activity/' + activityId + '/register';
    return (dispatch, getState) => {
        var oldPool = getState().registerActivitiesReducer.rootActivity.pool;

        // uncommented since page  is reloaded (y)
        dispatch(updatePoolRequest(val));
        return httpPost(_url, { hours: val, date: date })
            .then(() => {
                dispatch(updatePoolSuccess());
            })
            .catch((e) => {
                dispatch(updatePoolFailure(oldPool));
                dispatch(addAlert(e.message))
            })
    };
}

export const UPDATE_TOTAL_REGISTERED_INIT = 'UPDATE_TOTAL_REGISTERED_INIT'
export const updateTotalRegisteredInit = (val) => {
    return {
        type: UPDATE_TOTAL_REGISTERED_INIT,
        val: val
    };
}


export const InitTotalRegistered = () => {
    return (dispatch, getState) => {
        const state = getState();
        var subtracted = 0;
        var keys = Object.keys(state.registerActivitiesReducer.activities);
        keys.forEach(key => {
            subtracted += parseFloat(state.registerActivitiesReducer.activities[key].todaysHrs)
        });
        dispatch(updateTotalRegisteredInit(subtracted));
    }
}

export const fetchActivity = (activityId, date) => {
    /*HACK to remove double quotes from json date
    see: http://weblog.west-wind.com/posts/2014/Jan/06/JavaScript-JSON-Date-Parsing-and-real-Dates*/
    date = JSON.parse(JSON.stringify(date));
    var _url = process.env.REACT_APP_webApiEndPoint + "api/activity/" + activityId + "?Date=" + date
    return (dispatch, getState) => {
        if (getState().activityOverviewReducer.project.number) {
            dispatch(attemptGetActivities(getState().activityOverviewReducer.project.number, false, date))
        }
        dispatch(getActivitiesRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => dispatch(getActivitySuccess(json)))
            .then(() => dispatch(InitTotalRegistered()))
            .catch((e) => {
                //TODO pushpath to previous kanban overview
                dispatch(routeActions.push('/tilbud'));
                dispatch(addAlert(e.message))
            })
    };
}

export const UPDATE_TOTAL_REGISTERED = 'UPDATE_TOTAL_REGISTERED'
export const updateTotalRegistered = (val, rootActivityId) => {
    return {
        type: UPDATE_TOTAL_REGISTERED,
        val: val,
        rootActivityId: rootActivityId
    };
}

export const UpdateActivity = (val, id) => {
    return (dispatch, getState) => {
        const state = getState();
        var subtracted = 0;
        var keys = Object.keys(state.registerActivitiesReducer.activities);
        keys.forEach(key => {
            if (key !== id) {
                subtracted += state.registerActivitiesReducer.activities[key].todaysHrs
            }
            else {
                subtracted += val
            }
        });
        dispatch(updateTodaysHrs(val, id));
        dispatch(updateTotalRegistered(subtracted, state.registerActivitiesReducer.rootActivity.id));
    }
}


export const UPDATE_TODAYSHRS = 'UPDATE_TODAYSHRS'
export const updateTodaysHrs = (val, id) => {
    return {
        type: UPDATE_TODAYSHRS,
        val: val,
        id: id
    };
}


export const SUBMIT_ACTIVITIES_REQUEST = 'SUBMIT_ACTIVITIES_REQUEST'
export const submitActivitiesRequest = () => {
    return {
        type: SUBMIT_ACTIVITIES_REQUEST
    }
}

export const SUBMIT_ACTIVITIES_SUCCESS = 'SUBMIT_ACTIVITIES_SUCCESS'
export const submitActivitiesSuccess = () => {
    return {
        type: SUBMIT_ACTIVITIES_SUCCESS
    }
}

export const SUBMIT_ACTIVITIES_FAILURE = 'SUBMIT_ACTIVITIES_FAILURE'
export const submitActivitiesFailure = () => {
    return {
        type: SUBMIT_ACTIVITIES_FAILURE
    }
}


export const submitActivities = (date, id, value, oldValue) => {
    return (dispatch, getState) => {
        dispatch(UpdateActivity(value, id));
        dispatch(submitActivitiesRequest());
        var activityId = getState().registerActivitiesReducer.rootActivity.id;
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/activity/' + activityId + '/registerHours';
        return httpPost(_url, { date: date, activityHours: [{ id: id, hours: value }] })
            .then(() => {
                dispatch(submitActivitiesSuccess());
            })
            .catch((e) => {
                dispatch(submitActivitiesFailure())
                dispatch(UpdateActivity(oldValue, id));
                dispatch(addAlert(e.message))
            })
    };
}



export const ADD_ACTIVITY_REQUEST = 'ADD_ACTIVITY_REQUEST'
export const addActivityRequest = (activityName, tempId) => {
    return {
        type: ADD_ACTIVITY_REQUEST,
        activity: {
            name: activityName,
            todaysHrs: 0,
            id: tempId
        }
    }
}

export const ADD_SUB_ACTIVITY_REQUEST = 'ADD_SUB_ACTIVITY_REQUEST'
export const addSubActivityRequest = (activityName, parentActivityId, tempId) => {
    return {
        type: ADD_SUB_ACTIVITY_REQUEST,
        parentActivityId: parentActivityId,
        activity: {
            name: activityName,
            todaysHrs: 0,
            id: tempId
        }
    }
}

export const ADD_ACTIVITY_SUCCESS = 'ADD_ACTIVITY_SUCCESS'
export const addActivitySuccess = (id, tempId) => {
    return {
        type: ADD_ACTIVITY_SUCCESS,
        tempId: tempId,
        id: id
    }
}

export const ADD_SUB_ACTIVITY_SUCCESS = 'ADD_SUB_ACTIVITY_SUCCESS'
export const addSubActivitySuccess = (id, tempId, parentActivityId) => {
    return {
        type: ADD_SUB_ACTIVITY_SUCCESS,
        tempId: tempId,
        id: id,
        parentActivityId: parentActivityId
    }
}

export const ADD_SUB_ACTIVITY_FAILURE = 'ADD_SUB_ACTIVITY_FAILURE'
export const addActivitySubFailure = (parentActivityId) => {
    return {
        type: ADD_SUB_ACTIVITY_FAILURE,
        parentActivityId: parentActivityId
    }
}

export const ADD_ACTIVITY_FAILURE = 'ADD_ACTIVITY_FAILURE'
export const addActivityFailure = () => {
    return {
        type: ADD_ACTIVITY_FAILURE
    }
}

export const addActivity = (activityName, parentActivityId) => {
    return (dispatch, getState) => {
        var tempId = "" + Math.random();
        var shouldAddChild = getState().registerActivitiesReducer.rootActivity.id === parentActivityId ? true : false;
        shouldAddChild ? dispatch(addActivityRequest(activityName, tempId)) : dispatch(addSubActivityRequest(activityName, parentActivityId, tempId));
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/activity/' + parentActivityId;
        return httpPut(_url, { name: activityName })
            .then(response => {
                return response.json();
            })
            .then(json => {
                shouldAddChild ? dispatch(addActivitySuccess(json, tempId)) : dispatch(addSubActivitySuccess(json, tempId, parentActivityId));
            })
            .catch(() => {
                shouldAddChild ? dispatch(addActivityFailure()) : dispatch(addActivitySubFailure(parentActivityId));
                dispatch(addAlert("Kunne ikke tilføje aktivitet"))
            })
    };
}



export const RENAME_ACTIVITIES_REQUEST = 'RENAME_ACTIVITIES_REQUEST'
export const renameActivitiesRequest = (renamedActivity) => {
    return {
        type: RENAME_ACTIVITIES_REQUEST,
        renamedActivity: renamedActivity
    }
}

export const RENAME_ACTIVITIES_SUCCESS = 'RENAME_ACTIVITIES_SUCCESS'
export const renameActivitiesSuccess = () => {
    return {
        type: RENAME_ACTIVITIES_SUCCESS
    }
}

export const RENAME_ACTIVITIES_FAILURE = 'RENAME_ACTIVITIES_FAILURE'
export const renameActivitiesFailure = (renamedActivity) => {
    return {
        type: RENAME_ACTIVITIES_FAILURE,
        renamedActivity: renamedActivity
    }
}


export const renameActivities = (renamedActivities) => {
    return (dispatch) => {
        var renamedActivityStripped = [];
        for (var i = 0; i < renamedActivities.length; i++) {
            dispatch(renameActivitiesRequest(renamedActivities[i]))
            renamedActivityStripped.push({ id: renamedActivities[i].id, name: renamedActivities[i].name })
        }
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/activity';
        return httpPut(_url, renamedActivityStripped)
            .then(() => {
                dispatch(renameActivitiesSuccess())
            })
            .catch(() => {
                for (var k = 0; k < renamedActivities.length; k++) {
                    dispatch(renameActivitiesFailure(renamedActivities[k]))
                }
                dispatch(addAlert("Kunne ikke skifte navn på aktivitet"))
            })
    };
}


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/actions.js